<template>
  <div style="background-color: #0081ff;height: 50px;line-height: 50px;text-align: left">
    <img src="../../assets/banner.png" alt="" style="margin-left: 20px;width: 36px;height: 38px;cursor: pointer;" @click="jump(location)">
    <span style="color: #FFF;font-size: 18px;margin-left: 10px;line-height: 50px;height: 50px;line-height: 50px;letter-spacing: 1px;">青岛升平电气试验报告验证后台系统</span>
  </div>
</template>

<script setup>
import {defineProps} from "vue";
defineProps(['location'])
const jump = (href) => {
    window.location.href = href;
}
</script>

<style scoped>

</style>